import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import ContactBlockPreview from "@project/components/ContactBlock/ContactBlockPreview";
export const ContactBlock = {
    label: "Bloc de contact",
    type: ContentsCustomTypes.CONTACT_BLOCK,
    Preview: ContactBlockPreview,
    icon: "address-card",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "Un projet à lancer, une équipe à mobiliser ?",
        },
        {
            label: "Sous-titre",
            key: "subtitle",
            type: ContentsTypes.INPUT,
            value: "Bénéficiez d'un accompagnement global porté par une équipe d'experts engagés",
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            children: [
                {
                    label: "URL",
                    key: "url",
                    type: ContentsTypes.URL,
                    value: "/contact",
                },
                {
                    label: "Titre du lien",
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "Nous contacter",
                },
            ],
            value: "",
        },
    ],
};
